import { Component, OnInit, } from '@angular/core';
import { RecentProjectsService } from "@shared/layout/header/recent-projects/recent-projects.service";
import { Router } from '@angular/router';
import { ManageStateService } from '@shared/manage-state.service';
import { CookieConfig } from '@util/variable';

@Component({
  selector: 'sa-recent-projects',
  templateUrl: './recent-projects.component.html',
  providers: [RecentProjectsService]
})
export class RecentProjectsComponent implements OnInit {

  projects: Array<any>;

  userName: string;
  tk: string;

  constructor(
    private projectsService: RecentProjectsService,
    private router: Router,
    private manageStateService: ManageStateService) {

  }

  ngOnInit() {
    // this.projects = this.projectsService.getProjects()
    this.userName = this.manageStateService.load(CookieConfig.NAME_COOKIE)
    this.tk = this.manageStateService.load(CookieConfig.NVID_COOKIE)

  }

  clearProjects() {
    // this.projectsService.clearProjects();
    // this.projects = this.projectsService.getProjects()

  }

  goToChangePassword() {
    this.router.navigate(['/sinhvien/thong-tin-ca-nhan/doi-mat-khau'])
  }
  goToHelp() { this.router.navigate(['/sinhvien/support']) }
}



// WEBPACK FOOTER //
// ./src/app/shared/layout/header/recent-projects/recent-projects.component.ts